/**
 * ProfileFocusChip — a slim, self-contained nudge toward /app/my-focus.
 * Fetches the user's own profile completeness and shows a gentle, dismissible
 * pill. Hidden once the profile is complete. No prop drilling — owns its fetch.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ChevronRight } from 'lucide-react';
import { authFetch } from '@/utils/authFetch';
import { API_URL } from '@/config/apiConfig';

export default function ProfileFocusChip() {
  const navigate = useNavigate();
  const [completeness, setCompleteness] = useState(null);

  useEffect(() => {
    let alive = true;
    authFetch(`${API_URL}/api/staff-profile/me`)
      .then((r) => r.json())
      .then((d) => { if (alive) setCompleteness(d?.completeness ?? null); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (completeness === null || completeness >= 100) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/app/my-focus')}
      data-testid="profile-focus-chip"
      className="w-full flex items-center gap-3 rounded-xl border border-indigo-100 bg-indigo-50/60 px-4 py-2.5 text-left hover:bg-indigo-50 transition-colors"
    >
      <span className="rounded-lg bg-indigo-100 p-1.5"><Sparkles className="w-4 h-4 text-indigo-600" /></span>
      <span className="flex-1 min-w-0">
        <span className="text-sm font-medium text-slate-800">Personalise your experience</span>
        <span className="block text-xs text-slate-500">
          Your focus profile is {completeness}% complete — a few quick answers sharpen your dashboard & Cory.
        </span>
      </span>
      <ChevronRight className="w-4 h-4 text-indigo-400 shrink-0" />
    </button>
  );
}
